import {mediaQueryBreakpointSM} from "../../utils/Utils.js";

const CoverVideo = (domEl) => {
	const videoBlock = domEl.querySelector('.core-cover-video');
	const videoSrc = videoBlock.getAttribute('data-src'); // Required
	const videoSrcXs = videoBlock.getAttribute('data-src_xs');

	if (!videoSrc) {
		return;
	}

	let videoEl = null;

	const setVideoSource = () => {
		if(window.matchMedia('(max-width: '+mediaQueryBreakpointSM+'px)').matches && videoSrcXs) {
			videoEl.src = videoSrcXs;
			domEl.classList.remove('js-desktop-video-shown');
			domEl.classList.add('js-mobile-video-shown');
		}
		else {
			videoEl.src = videoSrc;
			domEl.classList.remove('js-desktop-video-shown');
			domEl.classList.add('js-mobile-video-shown');
		}
	};

	const render = () => {
		if(!videoEl) {
			videoEl = document.createElement('video');
			videoEl.playsInline = true;
			videoEl.controls = false;
			videoEl.muted = true;
			videoEl.autoplay = true;
			videoEl.loop = true;

			videoBlock.appendChild(videoEl);
			domEl.classList.add('js-video-added');
		}

		setVideoSource();
	};

	const mediaQueryList = window.matchMedia('(max-width: 767px)');
	mediaQueryList.addEventListener('change', setVideoSource);

	render();
};

export default CoverVideo;